import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext } from 'commons-ui';
import _get from 'lodash/get';
import { dehydrateFormData, hydrateHappyHourFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { IHappyHourTemplate } from '../../interfaces';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdateHappyHour } = useService();

	const updateHappyHour = (updatedData: { happyHourData: IHappyHourTemplate }) => {
		setShowLoader(true);

		const { happyHourData } = updatedData;

		requestUpdateHappyHour(app.appName, happyHourData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while updating the happy hour template', { type: 'error' });
					setShowLoader(false);
					return;
				}

				showAlert('Happy hour template updated');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: IHappyHourTemplate) => {
		updateHappyHour(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateHappyHourFormData(_get(location, ['state', 'rowData'])),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
